import React from "react";
import {Security, Reliability, Stability, Simplicity} from '../../components/svgs/qm'; 

const featuresFr = [
  {
    title: 'Stabilité',
    description: 'Notre solution est robuste et éprouvée dans des sites à fort achalandage.',
    picto: <Stability />
  },
  {
    title: 'Fiabilité',
    description: 'Grâce à notre solution cloud, votre file d\'attente est toujours en ligne et les mises à jour logicielles sont facilement déployées. ',
    picto: <Reliability />
  },
  {
    title: 'Sécurité',
    description: 'Notre solution offre une sécurité maximale et répond aux normes rigoureuses des grandes entreprises aux standards les plus élevés partout dans le monde.',
    picto: <Security />
  },
  {
    title: 'Simplicité',
    description: 'Facile à mettre en place, Moviik est conçue pour être simple d\'utilisation rapide et efficace. ',
    picto: <Simplicity />
  },
];

const featuresEn = [
  {
    title: 'Stability',
    description: 'Our solution is robust and proven in high traffic sites.',
    picto: <Stability />
  },
  {
    title: 'Reliability',
    description: 'With our cloud solution, your queue is always online and software updates are easily deployed.',
    picto: <Reliability />
  },
  {
    title: 'Security',
    description: 'Our solution offers maximum security and meets the rigorous standards of large companies with the highest standards around the world.',
    picto: <Security />
  },
  {
    title: 'Simplicity',
    description: 'Easy to set up, Moviik is designed to be easy to use, quick and efficient.',
    picto: <Simplicity />
  },
];

export {featuresFr, featuresEn};
